<template>
    <Button :empty="empty" @click.prevent="onClockCreateClick">
        <template>
            Create a new Clock
        </template>
    </Button>
</template>
<script>
    import EventBus from '@/eventbus';
    import Button from '@/components/common/Button.vue'
    export default {
        name: "ClockCreationButton",
        extends: Button,
        props: {
            empty: { type: Boolean, required: true, default: false },
        },
        methods: {
            onClockCreateClick: () => { EventBus.$emit('onClockCreation'); },
        }
    }
</script>

<style scoped>
</style>
